<template>
    <div>   <a-drawer
            :title='title'
            :visible="visible"
            v-bind="drawerConfig"
            :body-style="{ paddingBottom: '80px' }"
            @close="onClose"
    >
        <a-form-model ref="ruleForm" :model="form" :label-col="labelCol" :rules="rules" v-bind="layout" class="formBox">
          <a-form-model-item
              ref="inquiry_field"
              label="询盘字段"
              prop="inquiry_field"
              :extra="formErr.inquiry_field"
              :validateStatus='!formErr.inquiry_field||formErr.inquiry_field==""?"":"error"'
          >
            <a-select v-model="form.inquiry_field">
              <a-select-option :value="item.value.toString()" v-for="item in formList ">
                {{item.name}}
              </a-select-option>
            </a-select>
          </a-form-model-item>
          <a-form-model-item
              ref="content"
              label="过滤内容"
              prop="content"
              :help="formErr.content"
              :validateStatus='!formErr.content||formErr.content==""?"":"error"'
              style="position: relative"
          >
            <a-input
                :maxLength=50
                v-model="form.content"
                @change="(e) => { formErr.content=''}"
                @blur="(e) => {  form.content = e.target.value.trim() }"
            />
            <a-tooltip placement="left" title="询盘字段包含过滤内容时，此询盘会进入垃圾询盘" style="position: absolute;left:-16px;top: 0px;cursor: pointer">
              <a-icon type="question-circle" />
            </a-tooltip>
          </a-form-model-item>
            <a-form-model-item
                    ref="times"
                    label="包含次数"
                    prop="times"
                    :help="formErr.times"
                    :validateStatus='!formErr.times||formErr.times==""?"":"error"'
            >
                <a-input-number
                    :precision="0"
                        :max=99999
                        v-model="form.times"
                        @change="(e) => { formErr.times=''}"
                        @blur="(e) => {  form.times = e.target.value.trim() }"
                />
            </a-form-model-item>
        </a-form-model>
        <div class="drawer-btn"  >

            <a-button type="primary" @click="onSubmit" :style="{ marginRight: '8px' }">
                确定
            </a-button>
            <a-button @click="onClose">
            取消
        </a-button>
        </div>
    </a-drawer></div>
</template>

<script>
    import {submitForm,drawerConfig,validator} from "../../../../utils/utils"
    import API from "../api";
    export default {
        name: "newForm",
        props: ["visible","title","editId"],
        data() {
            return {
              labelCol: { span:5 },
              formList:null,
                drawerConfig ,
                form: {
                  inquiry_field:"",
                  content:"",
                  times:"1"
                },
                formErr: {
                  inquiry_field:"",
                  content:"",
                  times:""
                },
                rules: {
                  inquiry_field: [{required: true, message: "请选择询盘字段",}, {
                    whitespace: true,
                    message: "请选择询盘字段 "
                  }, {
                    validator: (rule, value, callback) => {
                      validator(rule, value, callback, this.formErr.inquiry_field)
                    }, trigger: "blur"
                  }],
                  content: [{required: true, message: "请输入过滤内容",}, {
                    whitespace: true,
                    message: "请输入过滤内容 "
                  }, {
                    validator: (rule, value, callback) => {
                      validator(rule, value, callback, this.formErr.content)
                    }, trigger: "blur"
                  }],

                  times:[{required: true, message: "请输入包含次数",}, {
                    whitespace: true,
                    message: "请输入包含次数 ", trigger: "blur"
                  }, {
                    validator: (rule, value, callback) => {
                      validator(rule, value, callback, this.formErr.times)
                    }, trigger: "blur"
                  }]
                       },


                layout: {
                    labelCol: { span: 4 },
                    wrapperCol: { span: 10 },
                },
            };
        },
        watch:{
            editId: function (a, b) {
                if (a != "") {
                    API.administrator. EDIT_DATA({id: a}).then(res => {
                        let val = res.data.data.info
                      val.inquiry_field= val.inquiry_field.toString()
                      val.times= val.times.toString()
                        this.form = val
                    })
                } else {
                    this.form.id = ''
                }
            }
        },
      mounted() {
        this.getFormList()
      },
      methods: {
          getFormList(){
            API.administrator.GET_FORM_LIST().then(res => {
              this.formList = res.data.data.inquiry_field
            })
          },
            onClose() {
                this.$emit("changVisible", false);
                this.formErr={
                  inquiry_field:"",
                  content:"",
                  times:""
                }
                this.$refs.ruleForm.resetFields();
            },
            onSubmit() {
                let _this = this;
                this.$refs.ruleForm.validate(valid => {
                    if (valid) {
                        let url
                        this.form.id == '' || this.form.id == undefined ? url = API.administrator.SUBMIT_ADD : url = API.administrator.SUBMIT_EDIT
                        submitForm(url, _this.form).then(res => {
                            if (res == true) {
                                this.onClose()
                            } else {
                                res.map((item, index) => {
                                    this.formErr[item.field] = item.msg
                                })
                            }
                        })
                    } else {
                        console.log('error submit!!');
                        return false;
                    }
                });
            },
        },
    }
</script>

<style scoped>

.formBox>>>.ant-form-item label{margin-right: 12px!important;}
</style>
